<template>
  <div class="icon">
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 494.000000 478.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,478.000000) scale(0.100000,-0.100000)"
        fill="#ff5353"
        stroke="none"
      >
        <path
          d="M642 4590 c-168 -25 -307 -168 -333 -343 -11 -82 -11 -3612 0 -3694
26 -179 164 -318 342 -343 85 -13 3613 -13 3698 0 178 25 316 164 342 343 12
83 11 3612 -1 3696 -25 178 -164 316 -343 342 -76 11 -3629 10 -3705 -1z
m3658 -2190 l0 -1800 -1800 0 -1800 0 0 1800 0 1800 1800 0 1800 0 0 -1800z"
        />
        <path
          d="M1640 2390 l0 -1050 240 0 240 0 0 266 0 266 137 144 c75 79 141 144
147 143 6 0 161 -184 344 -410 l333 -409 275 0 c150 0 274 2 274 5 0 3 -205
265 -455 582 -455 574 -456 576 -437 597 10 11 196 212 413 446 217 234 403
436 413 448 l19 22 -264 0 -264 0 -465 -491 -465 -491 -3 491 -2 491 -240 0
-240 0 0 -1050z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Outlet",
};
</script>
<style scoped>
.icon {
  height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/icons/Logo.vue